import React from 'react';
import { BOX_IMG, PRICING_ANCHOR } from './constants';
interface BoxImageProps {
  className?: string;
  wrapperClassName?: string;
}
export function BoxImage({
  className = '',
  wrapperClassName = ''
}: BoxImageProps) {
  return <a href={PRICING_ANCHOR} className={`block cursor-pointer ${wrapperClassName}`} aria-label="Vai all'offerta di RUNNING COACH PRO" data-id="element-29" data-mp="2rsw0tdu13o3r">
      <img src={BOX_IMG} alt="RUNNING COACH PRO — Sistema Completo 6-in-1 per Running Coach" className={`w-full h-auto object-contain mx-auto hover:scale-[1.02] transition-transform duration-300 ${className}`} data-id="element-30" data-mp="1z48a32qig6it" />
    </a>;
}